import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AppCoreService } from "src/app/services/app-core.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { Title } from "@angular/platform-browser";
@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
})

export class ListChargesComponent implements OnInit, OnDestroy {
    chargesList: any[];
    isActionAllowed = true;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        sortable: true,
        resizable: false,
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight'
    }

    columnDefs = [
        { headerName: 'Name', field: 'name', filter: true },
        { headerName: 'HSN Code', field: 'hsncode', filter: true },
        { headerName: 'Amount', field: 'amount', filter: true },
        {
            headerName: 'Status',
            field: 'status',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge bg-dark">Not Active</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Active</span>';
                }
                return statusHtml;
            }
        },
        {
            headerName: 'Actions',
            field: 'id',
            // cellRendererParams: { context: this },
            cellRenderer: EditDeleteActionsRenderer,
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 150,
        },
    ];
    rowData = [];

    constructor(
        public router: Router,
        private appCoreService: AppCoreService,
        private ngxLoaderService: NgxUiLoaderService,
        private chargesService: ChargesService,
        private titleService: Title
    ) {
        titleService.setTitle('Charges');
        this.context = { componentParent: this, componentName: 'ListChargesComponent', };
    }

    ngOnInit(): void {
        this.checkPermission();
        this.bindChargesList();
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData(); 
        const permission = userData.config.filter(x => x.categoryname === 'Manage');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }
    bindChargesList(refresh = false) {
        try {
            this.ngxLoaderService.start();
            this.chargesService.GetAllList({refresh: refresh}).subscribe((res: any) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.rowData = res.data;
                } else {
                    this.ngxLoaderService.stop();
                }
            })
        } catch (e) {
            console.error(e);
            this.ngxLoaderService.stop();
        }
    }

    ngOnDestroy(): void {

    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setDomLayout("autoHeight");
        params.api.sizeColumnsToFit();
    }

    editAction(cell: any) {
        try {
            if (cell && cell.id) {
                this.router.navigate(['/config/charges/manage/edit', cell.id]);
            }

        } catch (e) {
            console.error(e);
        }

    }

    deleteAction(cell: any) {
        if (cell && cell.id) {
            this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
        }

    }

    deleteRecord(id) {
        try {
            if (id) {
                this.ngxLoaderService.start();
                this.chargesService.Delete(id).subscribe((res) => {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.bindChargesList(true);
                        this.appCoreService.showMessage('Record deleted successfuly','Success','success');
                    }
                });
            }
        } catch (e) {
            this.ngxLoaderService.stop();
            console.error(e);
        }
    }

    async openConfirmationDialog(msg: any, id?: number) {
        const result = await Swal.fire({
            titleText: 'Confirmation',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Yes',
            showDenyButton: true,
            denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            // call delete api
            this.deleteRecord(id);

        }

    }
}

